import apiAutenticacao from "./api/autenticacao.js"

const pessoaRelacionamento = {
  /**
   * Busca relacionamentos da pessoa
   *
   * @param {pessoaFisicaId}
   * @return {Promise} response.data ou erro
   */
  relacionamentos (pessoaFisicaId) {
    return new Promise((resolve, reject) => {
      apiAutenticacao
        .get(`pessoa-relacionamento/listar/${pessoaFisicaId}`,
          {
            header: {
              Accept: "application/json",
              Content: "application/json",
            },
          })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  validarMatricula (matricula) {
    return new Promise((resolve, reject) => {
      apiAutenticacao
        .get(`pessoa-relacionamento/validar-matricula/${matricula}`,
          {
            header: {
              Accept: "application/json",
              Content: "application/json",
            },
          })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },


}

export default pessoaRelacionamento
